<template>
  <div class="row discountcode">
    <div class="col-12 discount_not_enough" v-if="this.$store.state.discount_not_enough">
      <svg class="icon-svg icon-svg--size-24 notice__icon" aria-hidden="true" focusable="false">
        <use xlink:href="#warning">
          <svg id="warning">
            <svg viewBox="0 0 24 22">
              <path
                fill="#b88600"
                d="M15.286 2.386l7.91 13.857C25.01 19.423 23.65 22 20.16 22H3.84C.35 22-1.01 19.427.805 16.243l7.91-13.857c1.815-3.178 4.754-3.185 6.57 0zm-1.737.992c-1.05-1.838-2.05-1.837-3.1 0L2.54 17.235C1.468 19.122 1.93 20 3.84 20h16.32c1.91 0 2.374-.88 1.298-2.765l-7.91-13.857zM12 6.5c.552 0 1 .448 1 1V12c0 .552-.448 1-1 1s-1-.448-1-1V7.5c0-.552.448-1 1-1zm-1.5 10c0-.828.666-1.5 1.5-1.5.828 0 1.5.666 1.5 1.5 0 .828-.666 1.5-1.5 1.5-.828 0-1.5-.666-1.5-1.5z"
              />
            </svg>
          </svg>
        </use>
      </svg>
      <div class="discount_not_enough_infor" v-html="this.$store.state.discount_not_enough"></div>
      <button class="iconfont icon-cancel-1-copy" @click="delete_discount_not_enough"></button>
    </div>
    <div
      class="col input_label"
      :class="{
        'inputerror':errorinfo,
        'had_input':code}"
    >
      <span>{{$t('shopping.discount_code')}}</span>
      <input type="text" v-model="code" :placeholder="$t('shopping.discount_code')" @keyup.enter="testdiscount()" />
    </div>
    <div class="col-3 button_wrap">
      <el-button
        :loading="loading"
        class="secondary_title"
        :class="code.trim()?'':'disable'"
        :disabled="code.trim()==''"
        @click="testdiscount"
      >{{apply == 'Apply' ? $t('shopping.apply') : apply}}</el-button>
    </div>
    <div class="col-12 discount_item">
      <template v-for="item in coupons">
        <p :key="item.code" v-if="!item.auto_coupon">
          <span class="iconfont icon-biaoqian">&nbsp;{{item.code}}</span>
          <i class="iconfont icon-cancel-1-copy" @click="deletediscount(item.code)"></i>
        </p>
      </template>
    </div>
    <div class="col-12 errorinfo" v-if="errorinfo">{{$t('shopping.valid_discount_code')}}</div>
  </div>
</template>
<script>
import API from "../../../API";
export default {
  props: ["getcoupons"],
  data() {
    return {
      apply: "Apply",
      loading: false,
      code: "",
      errorinfo: "",
      coupons: [],
      cart_hash:window.location.pathname.split('/')[2],
      utm_medium:null
    };
  },
  methods: {
    delete_discount_not_enough() {
      this.$store.dispatch("change_discount_not_enough", "");
    },
    async deletediscount(code) {
      try {
        this.utm_medium=this.getSearch('utm_medium');
        let searchData=this.utm_medium?`?cart_hash=${this.cart_hash}&utm_medium=${this.utm_medium}`:`?cart_hash=${this.cart_hash}`;
        let res = await this.$axios.delete(API.deletediscount + encodeURIComponent(code)+searchData);
        this.$emit("newcartmes", res.data);
        this.coupons = res.data.coupons;
        console.log(res);
        this.$store.dispatch("change_news_cart", res.data);
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },
    async testdiscount() {
      try {
        this.errorinfo = "";
        this.loading = true;
        this.apply = "";
        this.utm_medium=this.getSearch('utm_medium');
        let discountData={
          cart_hash:this.cart_hash,
          code: this.code
        };
        if(this.utm_medium){
          discountData.utm_medium=this.utm_medium;
        }
        let res = await this.$axios.post(API.testdiscount, discountData);
        console.log(res);
        this.$store.dispatch("change_news_cart", res.data);
        this.code = "";
        this.coupons = Object.values(res.data.coupons);
        this.loading = false;
        this.apply = "Apply";
      } catch (error) {
        this.loading = false;
        this.apply = "Apply";
        if (error.response.data.status_code == 422) {
          this.errorinfo = error.response.data.errors.code[0];
        } else if (error.response.data.status_code == 400) {
          this.code='';
          console.log(error.response);
          this.$store.dispatch(
            "change_discount_not_enough",
            error.response.data.message
          );
        } else {
          this.$message.error(error.response.data.message);
        }
      }
    }
  },
  beforeMount() {
    this.coupons = this.getcoupons;
  },
  watch: {
    getcoupons() {
      this.coupons = this.getcoupons;
      console.log("watch", this.coupons);
    },
    "$store.state.news_cart"() {
      this.coupons = Object.values(this.$store.state.news_cart.coupons);
    }
  }
};
</script>
<style scoped lang='scss'>
.discountcode {
  padding: 21px 0;
  margin: 0;
  .discount_not_enough {
    border: 1px solid #f0e4bc;
    background-color: #fff8de;
    padding: 14px;
    margin-bottom: 20px;
    display: flex;
    svg {
      width: 24px;
      height: 24px;
      margin-top: -2px;
      margin-right: 10px;
    }
    div {
      flex: 1;
    }
    .discount_not_enough_infor {
      font-size: 14px;
      color: #545454;
    }
    button {
      width: 46px;
      height: 46px;
      font-size: 14px;
      color: #545454;
      padding: 16px;
      margin-top: -16px;
      margin-right: -16px;
      border: none;
      background-color: transparent;
    }
  }

  .input_label {
    padding-left: 0;
    position: relative;

    input {
      padding-left: 11px;
      width: 100%;
      height: 46px;
      font-size: 12px;
      border: 1px solid #d9d9d9;
      border-radius: 5px;
    }

    input:focus {
      outline: none;
      box-shadow: 0 0 0 1px #128fae;
      border-color: #0f88a7;
      border-radius: 5px;
    }

    span {
      display: none;
      font-size: 12px;
      position: absolute;
      top: 4px;
      left: 12px;
    }
  }
  .inputerror {
    input {
      border-color: #e32c2b !important;
      box-shadow: 0 0 0 1px #e32c2b !important;
    }
  }

  .had_input {
    input {
      padding: 21px 29px 5px 11px !important;
      font-size: 12px !important;
    }
    span {
      display: inline-block !important;
    }
  }
  .discount_item {
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
    p {
      margin-bottom: 0;
      margin-top: 12px;
      margin-right: 15px;
      border-radius: 5px;
      background: #eeeeee;
      float: left;
      font-size: 12px;
      color: #666;
      padding: 8px 10px;
      span,
      i {
        font-size: 12px;
      }
      i {
        cursor: pointer;
        margin-left: 5px;
      }
    }
  }
  .button_wrap {
    padding: 0 0 0 12px;
    button {
      padding: 13px 0;
      width: 100%;
      background: #128fae;
      border: none;
      text-align: center;
      font-size: 16px;
      color: white;
      border-radius: 5px;
    }

    .disable {
      background: #c8c8c8;
      color: white;
    }
  }

  .errorinfo {
    padding: 0;
    color: red;
    font-size: 14px;
    margin: 8px 0;
  }
}
</style>